import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appDateFormat]',
  standalone: true
})
export class DateFormatDirective {
  private maxLength = 10; // MM/DD/YYYY length including slashes

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInput(event: Event): void {
    const input = this.el.nativeElement as HTMLInputElement;
    const rawValue = input.value;
    const prevPos = input.selectionStart || 0;

    // Only format if not deleting
    if ((event as InputEvent).inputType === 'deleteContentBackward' || (event as InputEvent).inputType === 'deleteContentForward') {
      this.validateDate(input);
      return;
    }

    let value = rawValue.replace(/[^0-9]/g, '');

    let formatted = '';
    let slashPositions = [2, 4];
    let addedSlash = false;
    let formattedIndex = 0;
    for (let i = 0; i < value.length && formatted.length < this.maxLength; i++) {
      if (slashPositions.includes(i) && formatted.length < this.maxLength) {
        formatted += '/';
        formattedIndex++;
        if (prevPos === formattedIndex) {
          addedSlash = true;
        }
      }
      formatted += value[i];
      formattedIndex++;
    }
    formatted = formatted.slice(0, this.maxLength);

    input.value = formatted;

    // Adjust cursor position: if a slash was just added at the cursor, move cursor after the digit
    let newPos = prevPos;
    if (
      addedSlash &&
      (prevPos === 3 || prevPos === 6)
    ) {
      newPos++;
    }
    input.setSelectionRange(newPos, newPos);

    this.validateDate(input);
  }

  private validateDate(input: HTMLInputElement): void {
    const value = input.value;
    if (value.length === this.maxLength) {
      const [month, day, year] = value.split('/').map(Number);
      const isValidMonth = month >= 1 && month <= 12;
      const isValidDay = day >= 1 && day <= 31;
      const isValidYear = year >= 1900 && year <= 9999;

      if (!isValidMonth || !isValidDay || !isValidYear) {
        input.setCustomValidity('Invalid date');
      } else {
        input.setCustomValidity('');
      }
    } else {
      input.setCustomValidity('');
    }
  }
}